import { render, staticRenderFns } from "./index.vue?vue&type=template&id=bf04f318&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "../../../../../styles/table.less?vue&type=style&index=0&id=bf04f318&lang=less&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&id=bf04f318&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf04f318",
  null
  
)

export default component.exports